// BANNER_HEIGHT를 0px로 설정 (다른 컴포넌트에서 사용)
export const BANNER_HEIGHT = "0px";

// Banner 컴포넌트는 아무것도 렌더링하지 않음
export const Banner = () => {
  return null;
};
